export const getNextRebootTime = (frequency, timeStr) => {
  if (!timeStr) return "-";
  const [hStr, mStr] = timeStr.split(":");
  const targetHour = parseInt(hStr, 10);
  const targetMinute = parseInt(mStr, 10);

  let targetDays = [];
  if (!frequency || frequency.toLowerCase() === "daily" || frequency === "0,1,2,3,4,5,6") {
    targetDays = [0, 1, 2, 3, 4, 5, 6];
  } else {
    targetDays = frequency.split(",").map(Number).filter((d) => !isNaN(d));
  }

  if (targetDays.length === 0) return "-";

  targetDays.sort((a, b) => a - b);

  const now = new Date();
  let nextRun = null;

  for (let i = 0; i <= 7; i++) {
    const d = new Date(now);
    d.setDate(now.getDate() + i);
    const dayOfWeek = d.getDay();

    if (targetDays.includes(dayOfWeek)) {
      d.setHours(targetHour, targetMinute, 0, 0);

      if (i === 0) {
        if (d.getTime() > now.getTime()) {
          nextRun = d;
          break;
        }
      } else {
        nextRun = d;
        break;
      }
    }
  }

  if (!nextRun) {
    return "-";
  }

  const yyyy = nextRun.getFullYear();
  const mm = String(nextRun.getMonth() + 1).padStart(2, "0");
  const dd = String(nextRun.getDate()).padStart(2, "0");
  const hh = String(nextRun.getHours()).padStart(2, "0");
  const min = String(nextRun.getMinutes()).padStart(2, "0");

  return `${yyyy}-${mm}-${dd} ${hh}:${min}`;
};

export const formatFrequencyText = (frequency) => {
  if (!frequency || frequency.toLowerCase() === "daily" || frequency === "0,1,2,3,4,5,6") {
    return "Daily";
  }
  const dayMap = {
    1: "Mon",
    2: "Tue",
    3: "Wed",
    4: "Thu",
    5: "Fri",
    6: "Sat",
    0: "Sun"
  };
  const selectedDays = frequency.split(",").map(Number);
  const sortedDays = [1, 2, 3, 4, 5, 6, 0].filter(d => selectedDays.includes(d));
  return sortedDays.map(d => dayMap[d]).join(", ");
};

export const formatTimeAMPM = (time24) => {
  if (!time24) return "";
  const [hStr, mStr] = time24.split(":");
  const h = parseInt(hStr, 10);
  const m = mStr || "00";
  let period = "AM";
  let hour12 = h;

  if (h >= 12) {
    period = "PM";
    if (h > 12) {
      hour12 = h - 12;
    }
  } else if (h === 0) {
    hour12 = 12;
  }

  return `${String(hour12).padStart(2, "0")}:${m} ${period}`;
};

export const formatTargetModelsText = (modelNames, deviceIds, devicesList = []) => {
  if (!modelNames || modelNames.length === 0) {
    const list = (deviceIds || []).map((mac) => {
      const dev = devicesList.find((d) => d.info?.macAddress === mac);
      return dev ? (dev.name || dev.info?.modelName || mac) : mac;
    });
    return {
      text: "Specific Devices",
      hasMore: false,
      tooltip: list.join(", "),
    };
  }

  const list = modelNames;
  if (list.length === 0) {
    return { text: "Specific Devices", hasMore: false, tooltip: "" };
  }
  if (list.length === 1) {
    return { text: list[0], hasMore: false, tooltip: list[0] };
  }
  const firstItem = list[0];
  const moreCount = list.length - 1;
  return {
    text: firstItem,
    hasMore: true,
    moreCount,
    tooltip: list.join(", ")
  };
};

export const getApiUrlAndParams = (action) => {
  const tmpSelectedBread = JSON.parse(localStorage.getItem("selectBreadcrumbs") || "{}");
  const hasManageOrg = tmpSelectedBread.realm?.hasManageOrg === true;

  const basePrefix = hasManageOrg ? "/ents/:entId" : "";
  const pathSuffix = action === "update" ? "/:scheduleRebootId.update" : `.${action}`;
  const apiUrl = `${basePrefix}/orgs/:orgId/sites/:siteId/settings/scheduleReboot${pathSuffix}`;

  const restfulParams = hasManageOrg
    ? {
        entId: tmpSelectedBread.realm?.id ?? null,
        orgId: tmpSelectedBread.orgs?.id ?? null,
        siteId: tmpSelectedBread.site?.id ?? null,
      }
    : {
        orgId: tmpSelectedBread.realm?.id ?? null,
        siteId: tmpSelectedBread.site?.id ?? null,
      };

  return { apiUrl, restfulParams };
};

export const getDevicesApiUrlAndParams = () => {
  const tmpSelectedBread = JSON.parse(localStorage.getItem("selectBreadcrumbs") || "{}");
  const hasManageOrg = tmpSelectedBread.realm?.hasManageOrg === true;

  const basePrefix = hasManageOrg ? "/ents/:entId" : "";
  const apiUrl = `${basePrefix}/orgs/:orgId/sites/:siteId/devices.read`;

  const restfulParams = hasManageOrg
    ? {
        entId: tmpSelectedBread.realm?.id ?? null,
        orgId: tmpSelectedBread.orgs?.id ?? null,
        siteId: tmpSelectedBread.site?.id ?? null,
      }
    : {
        orgId: tmpSelectedBread.realm?.id ?? null,
        siteId: tmpSelectedBread.site?.id ?? null,
      };

  return { apiUrl, restfulParams };
};
